// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".load-scale-enter-active[data-v-d960adee],\n.load-scale-leave-active[data-v-d960adee] {\n  transition: opacity 0.18s ease, transform 0.18s ease;\n}\n.load-scale-enter-from[data-v-d960adee],\n.load-scale-leave-to[data-v-d960adee] {\n  opacity: 0;\n  transform: scale(0.98);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
